
import axios from 'axios';
export const dashboardMethodUIHelpers = {
    onSearchInputFocus() {
        this.isSearchInputActive = true;
    },

    onSearchInputClick() {
        this.isSearchInputActive = true;
    },

    onSearchInputBlur() {
        this.isSearchInputActive = false;
    },

    addFrequentlyUsedTile(bookCode, tileId) {
        if (!bookCode || !tileId) {
            return Promise.resolve();
        }

        const bodyFormData = new FormData();
        bodyFormData.append('book_code', bookCode);
        bodyFormData.append('tile_id', tileId);

        return axios({
            method: 'post',
            url: this.baseAPIURL + '/apiv3/addfrequentlyusedtile.json',
            data: bodyFormData,
            headers: {
                auth: this.$store.getters.auth_token,
                'Content-Type': 'multipart/form-data',
            },
        }).catch(() => null);
    },

    trackFrequentlyUsedTile(bookCode, tileId) {
        if (!bookCode || !tileId) {
            return Promise.resolve();
        }

        const now = Date.now();
        const isDuplicateRapidOpen =
            Number(this.lastFrequentTrackTileId) === Number(tileId) &&
            this.lastFrequentTrackBookCode === bookCode &&
            now - (this.lastFrequentTrackAt || 0) < 1500;

        if (isDuplicateRapidOpen) {
            return Promise.resolve();
        }

        this.lastFrequentTrackTileId = Number(tileId);
        this.lastFrequentTrackBookCode = bookCode;
        this.lastFrequentTrackAt = now;

        return this.addFrequentlyUsedTile(bookCode, tileId).then(() => {
            if (this.selected_book === bookCode && typeof this.fetchFrequentlyUsedTiles === 'function') {
                return this.fetchFrequentlyUsedTiles(bookCode);
            }

            return null;
        });
    },

    removeFrequentlyUsedTile(tileId) {
        if (!tileId) {
            return Promise.resolve();
        }

        const bodyFormData = new FormData();
        bodyFormData.append('tile_id', tileId);

        return axios({
            method: 'post',
            url: this.baseAPIURL + '/apiv3/removefrequentlyusedtile.json',
            data: bodyFormData,
            headers: {
                auth: this.$store.getters.auth_token,
                'Content-Type': 'multipart/form-data',
            },
        }).catch(() => null);
    },

    onFrequentTileSelect(tile) {
        if (!tile || !tile.tile_id) {
            return;
        }

        this.isSearchInputActive = false;
        this.tile_selected(this.selected_book, tile.tile_id);
    },

    onFrequentTileRemove(tile) {
        if (!tile || !tile.tile_id) {
            return;
        }

        return this.removeFrequentlyUsedTile(tile.tile_id).then(() => {
            this.frequentTilesCurrentBook = (this.frequentTilesCurrentBook || []).filter((item) => {
                return Number(item.tile_id) !== Number(tile.tile_id);
            });
        });
    },

    waitForElement(selector, timeout = 2000) {
        return new Promise((resolve, reject) => {
        const interval = 50;
        let elapsed = 0;
        const check = () => {
            const el = document.querySelector(selector);
            if (el) return resolve(el);
            elapsed += interval;
            if (elapsed >= timeout) return reject(`Element ${selector} not found`);
            setTimeout(check, interval);
        };
        check();
        });
    },
    toggleSubItems(index, title) {
            if (this.openSections === index) {
                this.openSections = null;
            } else {
                this.openSections = index;
            }
    
            this.selected_page = title;
            this.$nextTick(() => {
                const sidebar = document.getElementById("pageScrollable");
                const activePage = document.getElementById(`page-${title}`);
                if (sidebar && activePage) {
                sidebar.scrollTo({
                    top: activePage.offsetTop - sidebar.offsetTop,
                    behavior: "smooth",
                });
                }
            }); 
    },
    isOpen(index) {
            return this.openSections === index;
    },
    detectMobile() {
                const userAgentCheck = /Mobile|Android|iPhone|iPad/i.test(navigator.userAgent) && navigator.userAgentData?.platform !== 'Windows' && navigator.userAgentData?.platform !== 'macOS';
                this.isMobile = userAgentCheck;
    },
    handle_error () {
                localStorage.clear();
                this.$moshaToast("Your session has expired. Please log in again.", { type: "warning" });
        
                // Add a delay before reloading the page
                setTimeout(() => {
                location.reload();
                }, 3000); // 5000 milliseconds = 5 seconds
    },
    handle_fileuploads(event) {
                const file = event.target.files[0];
        
                if (file) {
                    var fileInput = document.querySelector(`input[type="file"][name="${event.target.name}"]`);
                    if (file.size > 5 * 1024 * 1024) {
                        fileInput.value = "";    
                        var fileSizeError = 'File size exceeds 5MB. Please choose a smaller file.';
                        this.$moshaToast(fileSizeError, { type: "danger" });
                    } else {
                        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
                        if (!allowedTypes.includes(file.type)) {
                            var fileTypeError = 'Invalid file type. Allowed types are PDF, JPEG, JPG, and PNG.';
                            // Reset the file input value
                            this.$moshaToast(fileTypeError, { type: "danger" });
                            fileInput.value = "";    
                        } else {
                            fileSizeError = ''; 
                            fileTypeError = '';
                            this.dynamic_mergecodes[event.target.name] = event.target.files[0].name;
                            const indexToUpdate = this.file_uploads.findIndex(item => item.tag_name === event.target.name);
        
                            // Check if an item with "tag_name" equal to "step2" was found
                            if (indexToUpdate !== -1) {
                                // Update the value of the item at the found index
                                this.file_uploads[indexToUpdate].value = event.target.files[0]; // Replace "new value" with your desired value
                            }
                        }
                    }
                }
    },
    handleDrop(event){
                event.preventDefault();
                if (event.target.tagName.toLowerCase() === 'div' && event.target.classList.contains('dropzone')) {
                
                    const div = event.target;
                    div.classList.remove('drop-zone-idle'); 
                    div.classList.remove('drop-zone-active'); 
                    div.classList.add('drop-zone-idle'); 
        
                    const droppedFiles = event.dataTransfer.files;
        
                    const droppedDiv = event.target;
                    const divName = droppedDiv.getAttribute('name');
        
                     // Update the input element's files property with the dropped file
                    const fileInput = document.querySelector(`input[type="file"][name="${divName}"]`);
                    
                    fileInput.files = droppedFiles;
                    
                    const file = fileInput.files[0];
        
                    var fileSizeError = ''; 
                    var fileTypeError = '';
                    if (file) {
                        if (file.size > 5 * 1024 * 1024) {
                            fileInput.value = "";    
                            fileSizeError = 'File size exceeds 5MB. Please choose a smaller file.';
                            this.$moshaToast(fileSizeError, { type: "danger" });
                        } else {
                            const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
                            if (!allowedTypes.includes(file.type)) {
                                fileTypeError = 'Invalid file type. Allowed types are PDF, JPEG, JPG, and PNG.';
                                // Reset the file input value
                                this.$moshaToast(fileTypeError, { type: "danger" });
                                fileInput.value = "";    
                            } else {
                                fileSizeError = ''; 
                                fileTypeError = '';
                                this.dynamic_mergecodes[divName] = file.name;
                                const indexToUpdate = this.file_uploads.findIndex(item => item.tag_name === divName);
            
                                // Check if an item with "tag_name" equal to "step2" was found
                                if (indexToUpdate !== -1) {
                                    // Update the value of the item at the found index
                                    this.file_uploads[indexToUpdate].value = file; // Replace "new value" with your desired value
                                }
                            }
                        }
                    }
                }
    },
    handleDragOver(event){
                event.preventDefault();
                let target = event.target;
                
                // Check if any parent element has the 'dropzone' class
                while (target && target !== event.currentTarget) {
                    if (target.classList.contains('dropzone')) {
                        // Your event handling logic here
                        target.classList.remove('drop-zone-idle'); 
                        target.classList.add('drop-zone-active'); 
                        return;
                    }
                    target = target.parentNode;
                }
    },
    handleDragLeave(event){
                event.preventDefault();
                let target = event.target;
                
                // Check if any parent element has the 'dropzone' class
                while (target && target !== event.currentTarget) {
                    if (target.classList.contains('dropzone')) {
                        // Your event handling logic here
                        target.classList.add('drop-zone-idle'); 
                        target.classList.remove('drop-zone-active'); 
                        return;
                    }
                    target = target.parentNode;
                }
    },
    gettheme() {
        
                var bodyFormData = new FormData();
                bodyFormData.append("email", this.$store.getters.auth_user);
        
                axios({
                    method: "post",
                    url: this.baseAPIURL+"/apiv3/theme.json",
                    data: bodyFormData,
                    headers: {
                        "auth": this.$store.getters.auth_token,
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(response => {
                    this.$store.dispatch("updateTheme", response.data.theme[0].web_main_page_icon);
                });
    },
    updatevhValue() {
        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;

        if (screenWidth >= 1537 && screenHeight >= 769.80) {
            this.vh3Value = 90;
            this.vh2Value = 68;
            this.vh1Value = 58;
        } else if (screenWidth >= 1253 && screenHeight >= 578) {
            this.vh3Value = 82;
            this.vh2Value = 60;
            this.vh1Value = 48;
        } else if (screenWidth >= 1025 && screenHeight >= 500) {
            this.vh3Value = 72;
            this.vh2Value = 50;
            this.vh1Value = 38;
        } else {
            this.vh3Value = 50;
            this.vh2Value = 38;
            this.vh1Value = 28;
        }
    },
    allow_lightbox() {
        // console.log("LIGHTBUX");
        this.allowLightbox = true;
    },
    onScroll ({ target: { scrollTop, clientHeight, scrollHeight }}) {
        if (scrollTop + clientHeight >= scrollHeight) {
            this.scrolled = true;
        } else {
            this.scrolled = false;
        }
    },
    mobile_only() {
        this.$moshaToast("This tile can only be accessible on Tap mobile app.", { type: "danger" });
    },
    close_update_modal() {
        this.update_modal = false;
    },
    show_update_book_modal(book) {
        this.update_modal = true;
        this.book_to_update = book;
    },
    async scrollFunc (element) {
            if (this.side_bar_page === false) {
                    this.$scrollTo('#tile'+element, 10, {
                        easing: 'ease', 
                        cancelable: false,
                        container: '#tileScrollable',
                    })
            } else {
                    this.$scrollTo('#sidebartile'+element, 100, {
                        easing: 'ease', 
                        cancelable: false,
                        container: '#tileScrollableSidebar',
                    })
            }
    }, 
    async scrollPageFunc (element) {
                if (this.side_bar_page === false) {
                    this.$scrollTo('#page'+element, 10, {
                        easing: 'ease', 
                        cancelable: false,
                        container: '#pageScrollable',
                    })
                }
    }, 

    datenow() {
        var today = new Date();
        return today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate();
    },

    getClockTime() {
        var now    = new Date();
        var hour   = now.getHours();
        var minute = now.getMinutes();
        var ap = "AM";
        if (hour   > 11) { ap = "PM";             }
        if (hour   > 12) { hour = hour - 12;      }
        if (hour   == 0) { hour = 12;             }
        if (hour   < 10) { hour   = "0" + hour;   }
        if (minute < 10) { minute = "0" + minute; }
        var timeString = hour + ':' + minute + " " + ap;
        return timeString;
    },

    replaceRange(s, start, end, substitute) {
        return s.substring(0, start) + substitute + s.substring(end);
    },

    containsKey(object, key) {
        return !!Object.keys(object).find(k => k.toLowerCase() === key.toLowerCase());
    },

    findKey(object, key) {
        return Object.keys(object).find(k => k.toLowerCase() === key.toLowerCase());
    },

    promiseState(p) {
        const t = {};
        return Promise.race([p, t])
          .then(v => (v === t)? "pending" : "fulfilled", () => "rejected");
    },

    checkUpdate() {
       var bodyFormData = new FormData();
       bodyFormData.append("code", this.books);


       axios({
            method: "post",
            url: this.baseAPIURL+"/apiv3/getallmodifieddate.json",
            data: bodyFormData,
            headers: {
                "auth": this.$store.getters.auth_token,
                "Content-Type": "multipart/form-data",
            },
        })
        .then(response => {
            //handle success
            if (response.data.result === "success") {
                  var book_modify_obj = [];
                  for(let i=0; i<this.local.books.length; i++) {
                      book_modify_obj.push({"code": this.local.books[i].code, "modified": this.local.books[i].modified}) 
                  }
                  response.data.data.map((item) => {
                      Object.keys(book_modify_obj).filter((key) => {
                        if (book_modify_obj[key].code == item.code) {
                              if (book_modify_obj[key].modified != item.modified) {
                                //    console.log(item.code+'has NEW UPDATES');
                                   this.withUpdates.push(item.code);
                              }
                        }
                      });
                  });
            }
        })
        .catch(error => {
            console.log("Error: "+ error);
           
        });
        

    },
    
    badgePack() {
        axios({
            method: "post",
            url: this.baseAPIURL+"/apiv3/badgepack.json",
            headers: {
                "auth": this.$store.getters.auth_token,
                "Content-Type": "multipart/form-data",
            },
        })
        .then(response => {
            //handle success
            if (response.data.status === "success") {
                this.badgepack_token = response.data.token;
            }
        });
    },

    getTileUrl(tileUuid) {
        if (!tileUuid) return '';
        const origin = window.location.origin;
        return `${origin}/tile/${encodeURIComponent(tileUuid)}`;
    },

    async copyTileUrl(tileUuid) {
        const url = this.getTileUrl(tileUuid);
        if (!url) return;
        try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(url);
            } else {
                const ta = document.createElement('textarea');
                ta.value = url;
                document.body.appendChild(ta);
                ta.select();
                document.execCommand('copy');
                document.body.removeChild(ta);
            }
            if (this && typeof this.$moshaToast === 'function') {
                this.$moshaToast('Link copied', { type: 'success' });
            } else {
                console.log('Link copied:', url);
            }
        } catch (err) {
            console.error(err);
            if (this && typeof this.$moshaToast === 'function') {
                this.$moshaToast('Copy failed', { type: 'danger' });
            } else {
                console.log('Copy failed');
            }
        }
    },

};